export const navigation = [
  {
    name: 'Dashboard',
    url: '/home',
    icon: 'icon-chart',
  },
  {
    name: 'Administração',
    url: '/administracao',
    icon: 'icon-settings',
    permissao: 'administracao',
    children: [
      {
        name: 'Cargos',
        url: '/administracao/cargos',
        icon: 'icon-home',
        permissao: 'cargos'
      },
      {
        name: 'Conselhos',
        url: '/administracao/conselhos',
        icon: 'icon-people',
        permissao: 'conselhos'
      },
      {
        name: 'Diretorias',
        url: '/administracao/diretorias',
        icon: 'icon-people',
        permissao: 'diretorias'
      },
      {
        name: 'Escolas',
        url: '/administracao/escolas',
        icon: 'icon-graduation',
        permissao: 'escolas'
      },
      {
        name: 'Funcionários',
        url: '/administracao/funcionarios',
        icon: 'icon-user',
        permissao: 'funcionarios'
      },
      {
        name: 'Nec Especiais',
        url: '/administracao/necessidadesEspeciais',
        icon: 'icon-heart',
        permissao: 'necessidades'
      },
      {
        name: 'Noções de Informática',
        url: '/administracao/cursosInformatica',
        icon: 'icon-mouse',
        permissao: 'nocoes'
      },
      {
        name: 'Parceiros',
        url: '/administracao/parceiros',
        icon: 'icon-people',
        permissao: 'parceiros'
      },
      {
        name: 'Patrocinadores',
        url: '/administracao/patrocinadores',
        icon: 'icon-people',
        permissao: 'patrocinadores'
      },
      {
        name: 'Projetos',
        url: '/administracao/projetos',
        icon: 'icon-note',
        permissao: 'projetos'
      },
      {
        name: 'Voluntários',
        url: '/administracao/voluntarios',
        icon: 'icon-user',
        permissao: 'voluntarios'
      },
      
    ]
  },
  {
    name: 'Biblioteca',
    url: '/biblioteca',
    icon: 'icon-book-open',
    permissao: 'biblioteca',
    children: [
      {
        name: 'Autores',
        url: '/biblioteca/autores',
        icon: 'icon-people',
        permissao: 'autores'
      },
      {
        name: 'Leitores',
        url: '/biblioteca/leitores',
        icon: 'icon-people',
        permissao: 'leitores'
      },
      {
        name: 'Categorias',
        url: '/biblioteca/categorias-livros',
        icon: 'icon-list',
        permissao: 'categoriasBiblioteca'
      },
      {
        name: 'Editoras',
        url: '/biblioteca/editoras',
        icon: 'icon-pencil',
        permissao: 'editoras'
      },
      {
        name: 'Idiomas',
        url: '/biblioteca/idiomas',
        icon: 'icon-speech',
        permissao: 'idiomas'
      },
      {
        name: 'Livros',
        url: '/biblioteca/livros',
        icon: 'icon-notebook',
        permissao: 'livros'
      },
      {
        name: 'Empréstimos',
        url: '/biblioteca/emprestimos',
        icon: 'icon-notebook',
        permissao: 'reservas'
      },
      {
        name: 'Reservas',
        url: '/biblioteca/reserva-livro',
        icon: 'icon-layers',
        permissao: 'reservas'
      },
    ]
  },
  {
    name: 'Blog',
    url: '/blog',
    icon: 'icon-bubbles',
    permissao: 'blog',
    children: [
      {
        name: 'Publicações',
        url: '/blog/publicacoes',
        icon: 'icon-note',
        permissao: 'publicacoes'
      },
     
    ]
  },
  {
    name: 'Configurações',
    url: '/configuracoes',
    icon: 'icon-settings',
    permissao: 'configuracoes',
    children: [
      {
        name: 'Empresas',
        url: '/configuracoes/empresas',
        icon: 'icon-organization',
        permissao: 'empresas'
      },
      {
        name: 'Grupo de Usuários',
        url: '/configuracoes/grupoUsuarios',
        icon: 'icon-people',
        permissao: 'grupos'
      },
      {
        name: 'Resetar senha',
        url: '/administracao/usuarios',
        icon: 'icon-user',
        permissao: 'usuarios'
      },
      {
        name: 'Site',
        url: '/configuracoes/site',
        icon: 'icon-people',
        permissao: 'site'
      },
    ]
  },
  
  {
    name: 'Cursos',
    url: '/cursos',
    icon: 'icon-graduation',
    permissao: 'cursos',
    children: [
      {
        name: 'Alunos',
        url: '/cursos/alunos',
        icon: 'icon-people',
        permissao: 'alunos'
      },
      {
        name: 'Categorias',
        url: '/cursos/categoria-cursos',
        icon: 'icon-list',
        permissao: 'categoriaCursos'
      },
      {
        name: 'Visualizar Frequência',
        url: '/cursos/frequencia-aluno',
        icon: 'icon-calendar',
        permissao: 'frequenciaAluno'
      },
      {
        name: 'Inserir Frequência',
        url: '/cursos/frequencia-professor',
        icon: 'icon-calendar',
        permissao: 'frequenciaProfessor'
        
      },
      {
        name: 'Gerenciar Cursos',
        url: '/cursos/gerenciar',
        icon: 'icon-settings',
        permissao: 'gerenciarCursos'
      },
      {
        name: 'Horário',
        url: '/cursos/turmas-alunos',
        icon: 'icon-calendar',
        permissao: 'notasAluno'
      },
      // {
      //   name: 'Horário',
      //   url: '/cursos/turmas-alunos',
      //   icon: 'icon-calendar',
      //   permissao: 'notasProfessor'
      // },
      {
        name: 'Módulos',
        url: '/cursos/modulos',
        icon: 'icon-layers',
        permissao: 'modulos'
      },
      {
        name: 'Visualizar Notas',
        url: '/cursos/notas-aluno',
        icon: 'icon-book-open',
        permissao: 'notasAluno'
      },
      {
        name: 'Inserir Notas',
        url: '/cursos/notas-professor',
        icon: 'icon-book-open',
        permissao: 'notasProfessor'
      },
      {
        name: 'Turmas',
        url: '/cursos/turmas',
        icon: 'icon-people',
        permissao: 'turmas'
      },
      {
        name: 'Turmas Finalizadas',
        url: '/cursos/turmas-finalizadas',
        icon: 'icon-settings',
        permissao: 'turmasFinalizadas'
      },
      {
        name: 'Relatórios',
        url: '/cursos/relatorios',
        icon: 'icon-book-open',
        permissao: 'frequenciaProfessor'       
      },
      {
        name: 'Categorias',
        url: '/cursos/categoria-cursos',
        icon: 'icon-list',
        permissao: 'categoriaCursos'
      }
    ]
  },


  {
    name: 'Eventos',
    url: '/eventos',
    icon: 'icon-calendar',
    permissao: 'eventos',
    children: [
      {
        name: 'Categorias',
        url: '/eventos/categoria-eventos',
        icon: 'icon-list',
        permissao: 'categoriasEventos'
      },
      {
        name: 'Gerenciar Eventos',
        url: '/eventos/gerenciar',
        icon: 'icon-settings',
        permissao: 'gerenciarEventos'
      },
/*       {
        name: 'Inscreva-se',
        url: '/eventos/inscritos',
        icon: 'icon-user-follow',
        permissao: 'inscrever'
      }, */
      
    ]
  },
  
  {
    name: 'Processo Seletivo',
    url: '/processo-seletivo',
    icon: 'icon-calendar',
    permissao: 'processoSeletivo',
    children: [
      {
        name: 'Inscrições',
        url: '/processo-seletivo/inscricoes',
        icon: 'icon-note',
        permissao: 'processoSeletivo'
      },
    ]
  },
];



// WEBPACK FOOTER //
// ./src/app/_nav.ts